<template>
  <div
    class="d-flex align-start"
    :class="{'flex-column': vertical}"
  >
    <div>
      <DatePicker
        v-model="startDate"
        @input="handleStartDateChanged"
        v-bind="{...$attrs, ...startDatePickerAttrs}"
        @date-picker-activated="val => $emit('date-picker-activated', val, 'start')"
      />
    </div>
    <div>
      <slot name="split">
        <div
          v-if="!vertical"
          class="mx-4 mt-4"
        >
          {{ rangeSeparatorText }}
        </div>
      </slot>
    </div>
    <div>
      <DatePicker
        v-model="endDate"
        @input="handleEndDateChanged"
        v-bind="{...$attrs, ...endDatePickerAttrs}"
        @date-picker-activated="val => $emit('date-picker-activated', val, 'end')"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from './DatePicker';

export default {
  name: 'DatePickerRange',
  components: {
    DatePicker
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    rangeSeparatorText: {
      type: String,
      default: 'to'
    },
    startDatePickerAttrs: {
      type: Object,
      default() {
        return {
          label: 'Start date'
        };
      }
    },
    endDatePickerAttrs: {
      type: Object,
      default() {
        return {
          label: 'End date'
        };
      }
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      startDate: null, // iso format 2020-08-15
      endDate: null,
      closeMenuOnBlur: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // let the date picker handle validation
          this.startDate = newVal[0];
          this.endDate = newVal[1];
          this.fixDateOrder();
        } else {
          this.startDate = null;
          this.endDate = null;
        }
      }
    }
  },
  methods: {
    handleStartDateChanged() {
      this.handleUpdate();
      this.$emit('startDateChanged', this.startDate);
    },
    handleEndDateChanged() {
      this.handleUpdate();
      this.$emit('endDateChanged', this.endDate);
    },
    fixDateOrder() {
      if (
        this.startDate && this.startDate !== '' &&
        this.endDate && this.endDate !== '' &&
        this.startDate > this.endDate
      ) {
        // switch the dates
        const tempStartDate = this.startDate;
        this.startDate = this.endDate;
        this.endDate = tempStartDate;
      }
    },
    handleUpdate() {
      this.fixDateOrder();
      this.$emit('input', [this.startDate, this.endDate]);
    }
  }
};
</script>

<style scoped>
</style>
